export default {
      id: "play-usage",
      viewBox: "0 0 494.942 494.942",
      url: __webpack_public_path__ + "img/icons.df848786.svg#play",
      toString: function () {
        return this.url;
      }
    }